// For when an Okta user creates Okta user
export const createOktaUser = ({
  token,
  appRoleAccess,
  email,
  client,
  agencies,
  firstName,
  lastName,
}) => ({
  HTTPMethod: "post",
  path: "/api/v1/sso/users",
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {
    data: {
      profile: {
        first_name: firstName,
        last_name: lastName,
        email,
      },
      access: appRoleAccess,
      agencies,
      client: {
        slug: client,
      },
    },
  },
});
